import React, { useState } from "react";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import { Button } from "components/ui/button";

const SortingBar = ({ onSortChange }) => {
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const fields = [
    { key: "name", label: "שם" },
    { key: "phone", label: "פלאפון" },
    { key: "product", label: "מוצר" },
    { key: "date", label: "תאריך" },
  ];

  const handleSortChange = (field) => {
    const newOrder = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);
    onSortChange({ sortField: field, sortOrder: newOrder });
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      {fields.map((field) => {
        const active = sortField === field.key;
        const Icon = active ? (sortOrder === "asc" ? FaSortUp : FaSortDown) : null;

        return (
          <Button
            key={field.key}
            variant={active ? "secondary" : "ghost"}
            onClick={() => handleSortChange(field.key)}
            className={`flex items-center gap-1 ${active ? "font-semibold" : ""}`}
          >
            <span>{field.label}</span>
            {Icon && <Icon className="opacity-80" />}
          </Button>
        );
      })}
    </div>
  );
};

export default SortingBar;
